import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as classes from './classes.module.scss';
import { rulersForDpi } from '../../config/dpi';

export default class Guids extends PureComponent {
  static propTypes = {
    posX: PropTypes.number.isRequired,
    centerX: PropTypes.number.isRequired,
    posY: PropTypes.number.isRequired,
    centerY: PropTypes.number.isRequired,
    dpi: PropTypes.number.isRequired,
    guidesVisible: PropTypes.bool.isRequired,
    widthVisible: PropTypes.bool.isRequired,
    heightVisible: PropTypes.bool.isRequired,

    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  };

  renderWallGuide(kind, position) {
    const {
      posX, posY, centerX, centerY, dpi, width, height
    } = this.props;
    const viewPortWidth = (centerX - posX) * 2;
    const viewPortHeight = (centerY - posY) * 2;
    let style = null;
    let className = null;
    if (kind === 'vertical' && posX < position && position < posX + viewPortWidth) {
      style = {
        left: (position - posX) * dpi,
        width: 0,
        top: 0,
        height: (height - posY) * dpi
      };
      className = classes.vertical;
    } else if (kind === 'horizontal' && posY < position && position < posY + viewPortHeight) {
      style = {
        left: 0,
        width: (width - posX) * dpi,
        top: (position - posY) * dpi,
        hight: 0
      };
      className = classes.horizontal;
    }
    if (!style) { return null; }
    return (
      <div
        className={ className }
        style={ style }
      />
    );
  }

  renderGrid(start, end, step, baseStart, size, isHorizonal) {
    const { dpi } = this.props;
    const res = [];
    let pos = start;
    while (pos <= end) {
      const style = isHorizonal ? {
        left: 0,
        width: size * dpi,
        top: (pos - baseStart) * dpi,
        hight: 0
      } : {
        left: (pos - baseStart) * dpi,
        width: 0,
        top: 0,
        height: size * dpi
      };
      const className = isHorizonal ? classes.gridH : classes.gridV;
      const line = (
        <div className={ className } style={ style } key={ pos } />
      );
      res.push(line);
      pos += step;
    }
    return res;
  }

  renderGrids() {
    const {
      posX, posY, centerX, centerY, dpi
    } = this.props;
    const viewPortWidth = (centerX - posX) * 2;
    const viewPortHeight = (centerY - posY) * 2;
    const { guideStep } = rulersForDpi(dpi);

    const startX = Math.ceil(posX / guideStep) * guideStep;
    const endX = posX + viewPortWidth;

    const startY = Math.ceil(posY / guideStep) * guideStep;
    const endY = posY + viewPortHeight;

    const x = this.renderGrid(startX, endX, guideStep, posX, viewPortHeight, false);
    const y = this.renderGrid(startY, endY, guideStep, posY, viewPortWidth, true);

    return (
      <>
        { x }
        { y }
      </>
    );
  }

  render() {
    const {
      widthVisible, width, heightVisible, height, guidesVisible
    } = this.props;
    const w = widthVisible ? this.renderWallGuide('vertical', width) : null;
    const h = heightVisible ? this.renderWallGuide('horizontal', height) : null;
    return (
      <>
        { w }
        { h }
        { guidesVisible ? this.renderGrids() : null }
      </>
    );
  }
}
